module.exports = __webpack_public_path__ + "img/Muses-ex-Echoes3.08091f74.png";